
export const apiUrl = 'https://api.medosphere.com';
export const uploadInitEndpoint = `${apiUrl}/upload/init`;
export const orderListUrl = `${apiUrl}/video/orders`;
export const reviewApiEndpoint = (orderID: number) => `${apiUrl}/video/orders/${orderID}/review`;
export const assignApiEndpoint = (orderID: number) => `${apiUrl}/video/orders/${orderID}/assign`;
export const startApiEndpoint = (orderID: number) => `${apiUrl}/video/orders/${orderID}/start`;
